import { useTranslation } from "react-i18next";
import PricingCards from "@/components/PricingCards";
import LaunchCountdown from "@/components/LaunchCountdown";

/**
 * /pricing — public pricing page.
 */
export default function Pricing() {
  const { t } = useTranslation();
  return (
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20">
      <div className="text-center max-w-3xl mx-auto mb-12">
        <h1
          className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-semibold mb-4 bg-gradient-to-r from-white to-slate-400 bg-clip-text text-transparent"
          data-testid="pricing-heading"
        >
          {t("pricing.title")}
        </h1>
        <p className="text-zinc-400 leading-relaxed">
          {t("pricing.subtitle")}
        </p>
      </div>

      <div className="flex justify-center mb-12">
        <LaunchCountdown />
      </div>

      <PricingCards layout="page" />
    </div>
  );
}
